module.exports = __webpack_public_path__ + "img/warehouse.1fc4b295.png";